const Layout = () => import('@/layout')
const parentLayout = () => import('@/layout/parentLayout')

export const asyncRoutes = [
]